/* import __COLOCATED_TEMPLATE__ from './list-empty-state.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import templateOnlyComponent from '@ember/component/template-only';

const ListEmptyState = templateOnlyComponent();
export default ListEmptyState;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Suggestions::ListEmptyState': typeof ListEmptyState;
  }
}
